import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-toast-warn',
  imports: [ CommonModule],
  templateUrl: './toast-warn.component.html',
  styleUrl: './toast-warn.component.css'
})
export class ToastWarnComponent {
  @Input() text : string = 'แจ้งเตือน!'
  @Input() detail: string = 'กรุณากรอกข้อมูลให้ครบถ้วน'
  @Input() timeIn : number = 3000
  @Input() isButton : boolean = true
  @Input() language : "TH" | "EN" = "TH"
  @Input() loading : boolean = true
  @Input() positionY : string = 'top'
  @Input() positionX : string = 'right'
  
  @Output() close = new EventEmitter<boolean>()

  progress = 100;
  private toastInterval: any;
    ngOnInit(): void {

    const stepTime = 50;
    const step = 100 / (this.timeIn / stepTime);
    if ( this.text === "แจ้งเตือน!"){
      this.text = this.language === 'TH' ? this.text : "Warning!"
    }

    clearInterval(this.toastInterval);
    this.toastInterval = setInterval(() => {
      this.progress -= step;
      if (this.progress <= 0) {
        this.onClickClose();
      }
    }, stepTime);
  }

  onClickClose() {
    this.close.emit(false)
  }
}

